"use client";
import Link from "next/link";
import { ArrowRight, Mail, Lock } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { pressContact as data } from "@/lib/data/press";

const accent = "var(--color-cyan)";

export function PressContact() {
  return (
    <Section id="press-contact" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-10 glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Purpose</th>
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Contact</th>
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Response</th>
                  </tr>
                </thead>
                <tbody>
                  {data.contacts.map((c) => (
                    <tr key={c.purpose} className="border-b border-[rgb(var(--border)/0.08)]">
                      <td className="px-4 py-3 align-top font-medium">{c.purpose}</td>
                      <td className="px-4 py-3 align-top" style={{ color: accent }}>{c.contact}</td>
                      <td className="px-4 py-3 align-top hidden md:table-cell text-[rgb(var(--fg-muted))]">{c.response}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
        <div className="mt-8 grid lg:grid-cols-3 gap-5">
          <Reveal delay={200}>
            <div className="glass rounded-2xl p-6 h-full lg:col-span-2" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4" style={{ color: accent }} />
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Resources for Media</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {data.resources.map((r, i) => (
                  <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{r}</li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={250}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <Lock className="h-4 w-4" style={{ color: accent }} />
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.embargo.title}</span>
              </div>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.embargo.body}</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
